import React from 'react';
import { Tag } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';

const OnlineBadge = () => (
    <Tag size="tiny" color="green" kind="hollow">
        <I18n k="collections_perseus.collection_page.seller_card.online" />
    </Tag>
);

export default OnlineBadge;
